import { IOperation } from '@/contracts/system-modules/sync/operation/IOperation'

export class OperationPage {
  operations: IOperation[]
  next: number
  hasMore: boolean

  constructor({ operations, next, hasMore }: { operations: IOperation[], next: number, hasMore: boolean }) {
    this.operations = operations
    this.next = next
    this.hasMore = hasMore
  }
}
